//@flow
import React, {useEffect, useState} from 'react';
import {useFormContext} from 'react-hook-form';
import {makeStyles} from '@material-ui/core';

import CustomTextEditor from '../../../../../../elements/CustomTextEditor/CustomTextEditor';
import {colors} from '../../../../../../assets/styles/colors';
import {
  QUICK_REPLY_FIELDS,
  QUICK_REPLY_MESSAGE_INTERPOLATION,
} from '../constants';

import type {TextState, TextAreaTextApi} from '@uiw/react-md-editor';
import {emojiCommand} from '../../../../../../elements/CustomTextEditor/EmojiCommand';

const useStyles = makeStyles(theme => ({
  actionButton: {
    padding: '5px 15px',
    fontSize: '12px',
    color: '#7B39FF',
    border: `1px solid ${colors.purple3}`,
    fontFamily: 'Poppins',
    fontWeight: 600,
    borderRadius: '20px',
  },
}));

export default function MessageField() {
  const classes = useStyles();

  const {register, setValue, getValues} = useFormContext();

  const [text, setText] = useState('');

  useEffect(() => {
    register(QUICK_REPLY_FIELDS.message);
  }, [register]);

  useEffect(() => {
    const message = getValues(QUICK_REPLY_FIELDS.message);
    setText(message);
  }, [getValues]);

  const extraCommands = [
    {
      name: 'Customer name',
      enabled: true,
      keyCommand: 'nombre_cliente',
      buttonProps: {'aria-label': 'Insert customer name'},
      icon: <div className={classes.actionButton}>Nombre de cliente</div>,
      execute: (state: TextState, api: TextAreaTextApi) => {
        api.replaceSelection(
          QUICK_REPLY_MESSAGE_INTERPOLATION.clientName.value
        );
      },
    },
  ];

  return (
    <CustomTextEditor
      placeholder="Mensaje"
      onChange={value => {
        setText(value);
        setValue(QUICK_REPLY_FIELDS.message, value);
      }}
      text={text}
      leftCommands={[emojiCommand]}
      extraCommands={extraCommands}
    />
  );
}
